import { defineStore } from 'pinia'
import { ApiRequest } from '@/requests/ApiRequest'
import type { Filter } from '@/typings/Filter'

const Assignments = defineStore('assignments', {
  getters: {
    api: () => new ApiRequest(),
  },
  actions: {
    async getTotals(filters: Filter) {
      return await this.api.get('/statistics/diff/assignmentsTotal', filters)
    },

    async getPeriod(filters: Filter) {
      return await this.api.get('/statistics/period/assignmentsPeriod', filters)
    },
  },
})

export default Assignments
